import type { ComponentPropsWithRef, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { HalloweenTrinket } from '@/components/halloween'

const labelClass =
  'font-heading text-brand-purple mb-2 block text-base font-semibold tracking-wider uppercase'

export const inputClass =
  'input-rock focus:border-brand-purple focus:ring-brand-purple w-full rounded-sm border border-[#d8cfe0] bg-[#f8f5fa] px-4 py-3 text-[#1a1a1a] placeholder:text-[#aaa] focus:ring-1 focus:outline-none'

export function FieldLabel({ htmlFor, children }: { htmlFor: string; children: ReactNode }) {
  return (
    <label htmlFor={htmlFor} className={labelClass}>
      {children}
    </label>
  )
}

export function FieldInput({ className, ...props }: ComponentPropsWithRef<'input'>) {
  const decorated = !['checkbox', 'radio', 'hidden', 'file', 'range', 'color'].includes(
    props.type ?? 'text'
  )
  return (
    <span className="relative block">
      <input className={cn(inputClass, className)} {...props} />
      {decorated && <HalloweenTrinket pool="button-bits" className="spoopy-field-charm" />}
    </span>
  )
}

export function FieldError({ id, message }: { id: string; message: string | undefined }) {
  if (!message) return null
  return (
    <p id={id} role="alert" className="mt-1 text-sm text-red-500">
      {message}
    </p>
  )
}
